import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsGlobalConfigurationRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-configure',
	path: '/jira/servicedesk/assets/configure/global',
};
